import { getSingleAgeRangeValue } from 'components/date/AgeRange'
import { AgeRangeType, GrupoAlvoBuscaAtivaVacinacaoEnum } from 'graphql/types.generated'
import { createValidator, ErrorObject, maxRange, minLength, minRange, msg, range, required } from 'util/validation'

import { BuscaAtivaVacinacaoFilterPopperFormModel, BuscaAtivaVacinacaoFormModel } from './model-buscaAtivaVacinacao'

const validationsByGrupoAlvo = {
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADOLESCENTES]: range(10, 19),
  [GrupoAlvoBuscaAtivaVacinacaoEnum.ADULTOS]: range(20, 59),
  [GrupoAlvoBuscaAtivaVacinacaoEnum.IDOSOS]: minRange(60),
}

const validationsGrupoAlvoCriancaByAgeRangeType = {
  [AgeRangeType.ANOS]: maxRange(9),
  // 12 meses * 9 anos + 11 meses
  [AgeRangeType.MESES]: maxRange(12 * 9 + 11),
  // 31 dias * 12 meses * 10 anos - 1 dia
  [AgeRangeType.DIAS]: maxRange(31 * 12 * 10 - 1),
}

export const validator = createValidator<BuscaAtivaVacinacaoFormModel>(
  {
    equipe: required,
    grupoAlvo: required,
    status: required,
    tipoVisualizacao: required,
  },
  (values: BuscaAtivaVacinacaoFormModel, errors: ErrorObject<BuscaAtivaVacinacaoFormModel>) => {
    const { grupoAlvo, faixaEtaria } = values
    const faixaEtariaToValidate = getSingleAgeRangeValue(faixaEtaria)
    const firstFaixaEtariaValue = faixaEtaria?.firstValue
    const secondFaixaEtariaValue = faixaEtaria?.secondValue

    if (faixaEtaria?.tipoFaixaEtaria === AgeRangeType.SEMANAS) {
      errors.faixaEtaria = msg('invalid', faixaEtaria?.tipoFaixaEtaria)
    } else if (grupoAlvo?.enum === GrupoAlvoBuscaAtivaVacinacaoEnum.CRIANCAS && !!faixaEtaria?.tipoFaixaEtaria) {
      errors.faixaEtaria = validationsGrupoAlvoCriancaByAgeRangeType[faixaEtaria?.tipoFaixaEtaria](
        faixaEtariaToValidate
      )
    } else if (grupoAlvo?.enum in validationsByGrupoAlvo) {
      errors.faixaEtaria =
        validationsByGrupoAlvo[grupoAlvo.enum](firstFaixaEtariaValue) ||
        validationsByGrupoAlvo[grupoAlvo.enum](secondFaixaEtariaValue)
    }

    return errors
  }
)

export const validatorFiltrosAvancados = createValidator<BuscaAtivaVacinacaoFilterPopperFormModel>({
  bairro: minLength(4, true),
  logradouro: minLength(2, true),
})
